import React from 'react'
import TablaVistaProformaLogistica from '../components/proformaLogistica/TablaVistaProformaLogistica'

const ProformaLogisticaView = () => {

    return (

        <div>

            <h3 className='mb-4'>Proformas logistica</h3>

            <div className='mt-4'>
                <TablaVistaProformaLogistica/>
            </div>

        </div>

    )

}

export default ProformaLogisticaView